import React from "react";
import { FormSection } from "../../components/Sign/Sign";

interface SignPageProps {
  startParam?: string | null;
}

export const SignPage: React.FC<SignPageProps> = ({ startParam }) => {
  return <FormSection startParam={startParam} />;
};
